import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../style.css";
import { error } from "jquery";
import Login from '../Login/login'
import { ReactComponent as LoadingIcon } from '../../../src/cpanel-loading.svg';
import { toast } from 'react-toastify';
import { API_URL } from "../../config";

export default function Register({ isEnquiry, handleIsEnquiry }) {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    companyName: "",
    companyIncorporationDate: "",
    companyFullAddress: "",
    email: "",
    gstin: "",
    pan: "",
    district: "",
    state: "",
    companyTelephone: "",
    otp: ""
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [failed, setFailed] = useState(false);
  const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(false);
  // const [isEnquiry, setIsSignUp] = useState(true);

  useEffect(() => {
    // const canvas = canvasRef.current;
    // const ctx = canvas.getContext('2d');
    // initializeCaptcha(ctx);
  }, []);

  const handleUserInputChange = (e) => {
    setUserInput(e.target.value);
  };
  //MODIFIED BY SHAHIN
  const handleChange = (e) => {
    const companyNameRegex = /^(?=(?:[^a-zA-Z0-9]*[a-zA-Z0-9]){3})[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]{3,}$/;

    // const companyNameRegex = /^(?!.*[\s!@#$%^&*(),.?":{}|<>]{2})[a-zA-Z0-9][a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]{4,}$/;
    let { name, value } = e.target;
    if (name === "phone") {
      value = value.toString().replace(/[^0-9]/g, ""); // Allow only numbers
      if (value.length > 10) {
          value = value.slice(0, 10); // Truncate to 10 digits
      }
  }

    if (name === "companyTelephone") {
      value = value.toString().replace(/[^0-9]/g, ""); // Allow only numbers
      if (value.length > 10) {
          value = value.slice(0, 10); // Truncate to 10 digits
      }
    }
    if (name === "firstName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }
    if (name === "lastName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }
    if (name === "middleName" && value.toString().length > 25) {
      value = value.toString().slice(0, 25); // Truncate to 26 characters
    }
    if (name === "gstin" && value.toString().length > 15) {
      value = value.toString().slice(0, 15); // Truncate to 16 characters
    }
    if (name === "pan" && value.toString().length > 10) {
      value = value.toString().slice(0, 10); // Truncate to 11 characters
    }
    if (name === "companyName" && value.toString().length > 50) {
      value = value.toString().slice(0, 50); // Truncate to 51 characters
    }
    if (name === "otp") {
      value = value.toString().replace(/[^0-9]/g, "");
      value=value.toString().trim().slice(0,4);
    }
    if (name === "companyIncorporationDate") {
      // Allow only numbers and dashes (for manual date entry)
      
      value = value.replace(/[^0-9-]/g, "");
      
      
      // Extract the year part and truncate it if it's longer than 4 digits
      const parts = value.split("-");
      
      if (parts[0] && parts[0].length > 4) {
        
          parts[0] = parts[0].slice(0, 4);
      }

      // Reassemble the date if applicable
      value = parts.join("-");
  }

    const updatedValues = { ...formData, [name]: value };
    setFormData(updatedValues);

    switch (name) {
      ///^[A-Za-z]+$/
      case "firstName":
        errors.firstName =
          value.trim() === ""
            ? "First name is required"
            : !/^[A-Za-z]+$/.test(value)
              ? "Name is invalid"
              : "";
        break;
      case "lastName":
        errors.lastName =
          value.trim() === ""
            ? "Last name is required"
            : !/^[A-Za-z]+$/.test(value)
              ? "Last name is invalid"
              : "";
        break;
      case "middleName":
        errors.middleName =
          value.trim() === "" // If the value is empty
            ? "" // No error for empty value
            : !/^[A-Za-z]+$/.test(value) // If the value contains invalid characters (not just letters)
              ? "Middle name is invalid" // Error message for invalid characters
              : "";
        break;
      case "phone":
          errors.phone = value.trim() ? "" : "Mobile is required";
          errors.phone = value.length > 9 ? "" : "Mobile is required";
        break;
      case "companyTelephone":
          errors.companyTelephone = value.trim()
            ? ""
            : "Company Telephone is required";
          errors.companyTelephone =
            value.length > 9 ? "" : "Company Telephone is required";
        break;
      case "companyName":
        errors.companyName = value.trim()
    ? companyNameRegex.test(value.trim())
        ? ""
        : "Please enter valid company name."
    : "Company Name is required";
    break;
      case "companyIncorporationDate":
        errors.companyIncorporationDate = value.trim()
          ? ""
          : "Company Incorporation Date is required";
        break;
      case 'gstin':
        if (!gstinRegex.test(value) && value.length > 0) {
          errors.gstin = 'Invalid GST Number';
        } else {
          if (value.length >= 12) {
            const pan = value.substring(2, 12);
            if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
              errors.pan = 'Invalid PAN Number';
              errors.gstin = 'Invalid GST Number';
            } else {
              errors.pan = '';
              errors.gstin = '';
              setFormData(prevState=>({
                ...prevState,
                "pan":pan,
                [name]:value
              }));
              console.log(formData);
            }
          } else if (value.length < 12) {
            console.log("sdhgjhgdfj");
            setFormData((prevState) => ({
                ...prevState,
                panNumber: '' // Set PAN number state
            }));
        }
        }
        break;
      case 'pan':
        errors.pan = value.trim() ? true : false;
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)) {
          errors.pan = 'Invalid PAN Number';
        } else {
          errors.pan = ''
        }
        break;
      case "email":
        errors.email = !/\S+@\S+\.\S+/.test(value) ? "Invalid email" : "";
        break;
      case "companyFullAddress":
        errors.companyFullAddress = value.trim()
          ? ""
          : "Company Address is required";
        break;
      case "state":
        errors.state = value.trim()
          ? ""
          : "State is required";
        break;
      case "district":
        errors.district = value.trim()
          ? ""
          : "District is required";
        break;
    }
  };
  //otp feature updated by shahin
  const [otpLoader, setOtpLoader] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  //  const [isOtpVerified, setIsOtpVerified] = useState((combinedFormData && combinedFormData.PersonalDetails) ? true : false);
  const [otpTimer, setOtpTimer] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const [remainingTime, setRemainingTime] = useState(45);
  useEffect(() => { }, [submitted, setSubmitted]);

  const handleSubmit = async (e) => {
    console.log(formData);
    e.preventDefault();
    setLoading(true);
    setFailed(false);
    setSubmitted(false);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }
    setErrors({});
    try {
      const data = await axios.post(
        `${API_URL}/auth/register/create_admin`,
        formData
      );
      toast.success("Message sent successfully.")
      setOtpSent(false)
      setIsOtpVerified(false)
      setResendOtp(false)
      console.log(data);
      setSubmitted(true);
      setFormData({
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        companyName: "",
        companyIncorporationDate: "",
        companyFullAddress: "",
        email: "",
        gstin: "",
        pan: "",
        district: "",
        state: "",
        companyTelephone: "",
      });
      setErrors({});
      setLoading(false);
    } catch (error) {
      toast.error(error.message)
      console.error("Error sending email", error);
      setFailed(true);
      setLoading(false);
    }
  };

  const validate = () => {
    let errors = {};
    if (!formData.firstName) errors.firstName = "First name is required";
    if (!formData.lastName) errors.lastName = "Last name is required";
    // if (!formData.designation) errors.designation = "Designation is required";
    if (!formData.email) errors.email = "Email is required";
    if (!formData.phone) errors.phone = "Phone number is required";
    if (!formData.companyTelephone) errors.companyTelephone = "Company Telephone number is required";

    if (!/^\d{10}$/.test(formData.phone))
      errors.phone = "Phone number is invalid";
    // if (!formData.password) errors.password = "Password is required";
    // if (!formData.confirmPassword)
    //   errors.confirmPassword = "Confirm Password is required";
    // if (formData.confirmPassword != formData.password)
    //   errors.confirmPassword = "Passwords do not match";
    // if (!userInput) errors.captchaText = "Captcha is required";
    // if (userInput !== captchaText)
    //   errors.captchaText = "Please enter correct captcha text";
    // company data
    if (!formData.companyName) errors.companyName = "Company name is required";
    if (!formData.companyIncorporationDate)
      errors.companyIncorporationDate =
        "Company Incorporation Date name is required";
    // if (
    //   !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(
    //     formData.gstin
    //   )
    // )
    //   errors.gstin = "GSTIN is invalid";
    // if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan))
    //   errors.pan = "PAN Number is invalid";
    if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = "Email is invalid";
    if (!formData.companyFullAddress)
      errors.companyFullAddress = "Company name is required";
    if (!formData.district) errors.district = "District is required";
    if (!formData.state) errors.state = "State is required";
    return errors;
  };
  //incorporation date updated by shahin
  const [inputType, setInputType] = useState("text");
  const handleFocus = () => {
    // Change input type to date when focused
    setInputType("date");
  };
  const handleBlur = () => {
    // Optionally, you can change the input type back to text when the user clicks out
    if (!formData.companyIncorporationDate) {
      setInputType("text");
    }
  };


  const startOtpTimer = () => {
    // setOtpSent(true);
    setRemainingTime(45);
    setResendOtp(false);
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          // setOtpSent(false);
          setResendOtp(true)
          return 45;
        }
        return prevTime - 1;
      });
    }, 1000);
    setOtpTimer(timer);
  };
  // Send OTP API call

  const sendOTP = () => {
    setOtpLoader(true);
    if (errors.phone || formData.phone === "") {
      setErrors({
        ...errors,
        ['phone']: 'Please enter a valid phone number',
      });
      setOtpLoader(false);
      return;
    }

    // Implement API call to send OTP
    // Example:
    //console.log("object")
    fetch(`${API_URL}/auth/register/send_mobile_otp`, {
      method: "POST",
      body: JSON.stringify({ mobile: formData.phone }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        setOtpLoader(false);
        if (response.ok) {
          toast.success("OTP sent successfully.")
          setOtpSent(true);
          startOtpTimer();
          setErrors({
            ...errors,
            ['phone']: '',
          });
          // setResendOtp(true);
          response.json().then((result) => {
          })
          // setFormErrors({ ...formErrors, mobile: '' });
        } else {
          const data = await response.json();
          // setFormErrors({ ...formErrors, mobile: data });
          setErrors({
            ...errors,
            ['phone']: data,
          });

        }
      })
      .catch((error) => {
        toast.error("Enable to send OTP")
        setOtpLoader(false);
      });
  };

  //verify otp
  // Verify OTP API call
  const verifyOTP = () => {
    // Implement API call to verify OTP
    // Example:
    //console.log("object")
    // setLoading(true);

    fetch(`${API_URL}/auth/register/verify_mobile_otp`, {
      method: 'POST',
      body: JSON.stringify({ mobile: formData.phone, otp: formData.otp }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        // setLoading(false);
        if (response.ok) {
          toast.success("OTP Verified successfully.")
          setIsOtpVerified(true)
          setResendOtp(false);
          setErrors({
            ...errors,
            ['otp']: '',
          });

        }
        else {
          response.json().then((error) => {
            setErrors({
              ...errors,
              ['otp']: error.message,
            });

            // setFormErrors({ ...formErrors, otp: error.message });
          })
        }
      })
      .catch(error => {
        // Handle error
      });
  };

  return (
   
          <>  <form
          onSubmit={handleSubmit}
          id="contact-form"
          className="default-form"
        >
          <div className="row clearfix">
            {/* modified by shahin */}
            <div className="col-lg-4 col-md-4 col-sm-12 form-group">
              <input
                id="firstName"
                type="text"
                name="firstName"
                placeholder="First name *"
                value={formData.firstName}
                onChange={handleChange}
                style={
                  errors.firstName ? { border: "1px solid red" } : {}
                }
              />
              {errors.firstName && (
                <span className="error" style={{ color: "red" }}>
                  {errors.firstName}
                </span>
              )}
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 form-group">
              <input
                type="text"
                name="middleName"
                placeholder="Middle Name"
                value={formData.middleName}
                onChange={handleChange}
              />
              {errors.middleName && (
                <span className="error" style={{ color: "red" }}>
                  {errors.middleName}
                </span>
              )}
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 form-group">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name *"
                value={formData.lastName}
                onChange={handleChange}
                style={
                  errors.lastName ? { border: "1px solid red" } : {}
                }
              />
              {errors.lastName && (
                <span className="error" style={{ color: "red" }}>
                  {errors.lastName}
                </span>
              )}
            </div>

            {/* <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                <input
                  type="text"
                  name="designation"
                  placeholder="Designation *"
                  value={formData.designation}
                  onChange={handleChange}
                  style={
                    errors.designation && { border: "1px solid red" }
                  }
                />
                {errors.designation && (
                  <span className="error" style={{ color: "red" }}>
                    {errors.designation}
                  </span>
                )}
              </div> */}

            {/* <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                <input
                  type="password"
                  name="password"
                  placeholder="Password *"
                  value={formData.password}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "10px 20px 10px 20px",
                    borderRadius: 6,
                    fontSize: "14px",
                    ...(errors.confirmPassword && {
                      border: "1px solid red",
                    }),
                  }}
                />
                {errors.password && (
                  <span className="error" style={{ color: "red" }}>
                    {errors.password}
                  </span>
                )}
              </div> */}

            {/* <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password *"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "10px 20px 10px 20px",
                    borderRadius: 6,
                    fontSize: "14px",
                    ...(errors.confirmPassword && {
                      border: "1px solid red",
                    }),
                  }} 
                />
                {errors.confirmPassword && (
                  <span className="error" style={{ color: "red" }}>
                    {errors.confirmPassword}
                  </span>
                )}
              </div> */}

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="phone"
                placeholder="phone *"
                value={formData.phone}
                onChange={handleChange}
                disabled={isOtpVerified}
                style={errors.phone ? { border: "1px solid red" } : {}}
              />
              {otpSent && !isOtpVerified && !resendOtp && (
                <div
                  style={{
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: 3

                  }}>
                  <h6
                    style={{
                      alignSelf: "flex-end",
                      color: "gray",
                      fontSize: 13,
                    }}
                  >
                    Resend OTP in: {remainingTime}s
                  </h6>
                </div>
              )}
              {resendOtp && !isOtpVerified &&
                <>
                  {otpLoader ? <LoadingIcon style={{
                    height: 35,
                    marginTop: 2,
                    width: 50
                  }} /> :
                    <button
                      type="button"
                      style={otpLoader ? {} : {
                        color: "blue",
                        fontSize: 14,
                        borderBottom: '1px solid blue',
                      }}
                      onClick={sendOTP}
                    >
                      Resend
                    </button>
                  }
                </>

                // <button
                //   type="button"
                //   style={otpLoader ? {} : {
                //     color: "blue",
                //     fontSize: 14,
                //     borderBottom: '1px solid blue',
                //   }}
                //   onClick={sendOTP}
                // >
                //   <LoadingIcon style={{
                //   height:35
                //  }}/>
                //   {/* {otpLoader ? <LoadingIcon style={{
                //   height:35
                //  }}/> : <> Resend </>} */}
                // </button>
              }

              {errors.phone && (
                <span className="error" style={{ color: "red" }}>
                  {errors.phone}
                </span>
              )}
            </div>
            {/* otp button and field */}


            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '50px'
              }}>
                {otpSent && <input
                  className="col-lg-8 col-md-8"
                  type="text"
                  name="otp"
                  placeholder="OTP *"
                  value={formData.otp}
                  onChange={handleChange}
                  disabled={isOtpVerified}
                  style={errors.otp ? { border: "1px solid red" } : {}}
                />}
                {otpLoader ? <LoadingIcon style={{
                  height: 35,
                  width: 50
                }} /> : <button
                  type="button"
                  style={
                    otpLoader
                      ? {
                        backgroundColor: "#FF6E2D",
                        color: "whitesmoke",
                        borderRadius: 4,
                        fontWeight: "bold",
                        fontSize: 15,
                        height: 30,
                        paddingLeft: 25,
                        paddingRight: 25,
                      }
                      : {
                        backgroundColor: "#FF6E2D",
                        color: "whitesmoke",
                        borderRadius: 4,
                        fontWeight: "bold",
                        fontSize: 15,
                        height: 30,
                        paddingLeft: 8,
                        paddingRight: 8,
                      }
                  }
                  onClick={otpSent ? verifyOTP : sendOTP}
                  disabled={isOtpVerified}
                >
                  {/* <i className="fas fa-arrow-circle-right" /> */}
                  <> {otpSent && isOtpVerified ? 'Verified' : otpSent ? 'Verify' : 'Get OTP'}</>
                </button>}
              </div>

              {errors.otp && (
                <span className="error" style={{ color: "red" }}>
                  {errors.otp}
                </span>
              )}
            </div>



            {/* otp button and field */}

            {/* company details */}
            <div className="col-lg-12 col-md-12 col-sm-12 form-group">
              <input
                type="text"
                name="companyTelephone"
                placeholder="Company Telephone *"
                value={formData.companyTelephone}
                onChange={handleChange}
                style={
                  errors.companyTelephone
                    ? { border: "1px solid red" }
                    : {}
                }
              />
              {errors.companyTelephone && (
                <span className="error" style={{ color: "red" }}>
                  {errors.companyTelephone}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="companyName"
                placeholder="Company Name *"
                value={formData.companyName}
                onChange={handleChange}
                style={
                  errors.companyName ? { border: "1px solid red" } : {}
                }
              />
              {errors.companyName && (
                <span className="error" style={{ color: "red" }}>
                  {errors.companyName}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type={inputType}
                name="companyIncorporationDate"
                placeholder="Company Incorporation Date *"
                value={formData.companyIncorporationDate}
                onChange={handleChange}
                onFocus={handleFocus} // Trigger to convert to date input on focus
                onBlur={handleBlur} // Optional, to change back to text if left empty
                style={{
                  width: "100%",
                  padding: "10px 20px 10px 20px",
                  borderRadius: 6,
                  fontSize: "14px",
                  ...(errors.companyIncorporationDate
                    ? {
                      border: "1px solid red",
                    }
                    : {}),
                }}
              // style={errors.phone && { border: "1px solid red" }}
              />
              {errors.companyIncorporationDate && (
                <span className="error" style={{ color: "red" }}>
                  {errors.companyIncorporationDate}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="gstin"
                placeholder="GSTIN"
                value={formData.gstin}
                onChange={handleChange}
                style={errors.gstin ? { border: "1px solid red" } : {}}
              />
              {errors.gstin && (
                <span className="error" style={{ color: "red" }}>
                  {errors.gstin}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="pan"
                placeholder="PAN Number"
                value={formData.pan}
                onChange={handleChange}
                style={errors.pan ? { border: "1px solid red" } : {}}
              />
              {errors.pan && (
                <span className="error" style={{ color: "red" }}>
                  {errors.pan}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                style={errors.email ? { border: "1px solid red" } : {}}
              />
              {errors.email && (
                <span className="error" style={{ color: "red" }}>
                  {errors.email}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="companyFullAddress"
                placeholder="Company Full Address *"
                value={formData.companyFullAddress}
                onChange={handleChange}
                style={
                  errors.companyFullAddress
                    ? {
                      border: "1px solid red",
                    }
                    : {}
                }
              />
              {errors.companyFullAddress && (
                <span className="error" style={{ color: "red" }}>
                  {errors.companyFullAddress}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="state"
                placeholder="State *"
                value={formData.state}
                onChange={handleChange}
                style={errors.state ? { border: "1px solid red" } : {}}
              />
              {errors.state && (
                <span className="error" style={{ color: "red" }}>
                  {errors.state}
                </span>
              )}
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 form-group">
              <input
                type="text"
                name="district"
                placeholder="District *"
                value={formData.district}
                onChange={handleChange}
                style={
                  errors.district ? { border: "1px solid red" } : {}
                }
              />
              {errors.district && (
                <span className="error" style={{ color: "red" }}>
                  {errors.district}
                </span>
              )}
            </div>
            

            <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn">
              {loading ? <LoadingIcon
                style={{
                  height: 50,
                  width: '100%'
                }}
              /> : <button
                className="theme-btn style-four"
                type="submit"
                name="submit-form"
                disabled={loading || !isOtpVerified} // Disable button while loading
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                // onClick={() => { handleSubmit() }}
              >
                Register
                {/* {loading ? (
                    <div className="spinner" />
                  ) : (
                    <>
                      <i className="fas fa-arrow-circle-right" />
                      Register
                    </>
                  )} */}
              </button>}
            </div>
          </div>
        </form>
        <div className="d-flex justify-content-center w-100 mt-3">
          {/* onClick={() => setIsSignUp(!isEnquiry)} */}
          <h6 onClick={() => { handleIsEnquiry(!isEnquiry) }} style={{ color: "darkblue", textDecoration: "underline", cursor: "pointer" }}>Already a user? Login</h6>
        </div></>
           
  );
}
